import { render, staticRenderFns } from "./IRShareInformationPage.vue?vue&type=template&id=f99acbe4"
import script from "./IRShareInformationPage.vue?vue&type=script&lang=js"
export * from "./IRShareInformationPage.vue?vue&type=script&lang=js"
import style0 from "./IRShareInformationPage.vue?vue&type=style&index=0&id=f99acbe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports